// TODO: Update with official branch information from Champions Academy
export interface Branch {
  id: string;
  slug: string;
  name: {
    en: string;
    ar: string;
  };
  address: {
    en: string;
    ar: string;
  };
  phone: string;
  image: string;
  availableSports: string[];
  facilities: (string | { en: string; ar: string })[];
  region: 'north' | 'central' | 'south';
  isMainBranch?: boolean;
}

export const branches: Branch[] = [
  {
    id: "north-gaza",
    slug: "north-gaza",
    region: "north",
    name: { en: "North Gaza Branch", ar: "فرع شمال غزة" },
    address: {
      en: "North Gaza, Palestine",
      ar: "شمال غزة، فلسطين"
    },
    phone: "+970 599 000 001",
    image: "/placeholder.svg",
    availableSports: ["football"],
    facilities: [
      { en: "Football Field", ar: "مرفق كرة قدم" },
      { en: "Internet (Wi-Fi)", ar: "انترنت" },
      { en: "24/7 Security", ar: "أمن على مدار الساعة" },
      { en: "Parking", ar: "موقف سيارات" },
      { en: "Cafeteria", ar: "كافتيريا" }
    ]
  },
  {
    id: "gaza-city",
    slug: "gaza-city",
    region: "north",
    name: { en: "Gaza City Branch", ar: "فرع مدينة غزة" },
    address: {
      en: "Gaza City, Palestine",
      ar: "مدينة غزة، فلسطين"
    },
    phone: "+970 599 000 002",
    image: "/placeholder.svg",
    availableSports: ["football", "basketball", "swimming", "tennis", "karate", "table-tennis", "squash", "dabke"],
    facilities: [
      { en: "Football Fields", ar: "ملاعب كرة قدم" },
      { en: "Basketball Court", ar: "ملعب كرة سلة" },
      { en: "Ground Tennis Court", ar: "ملعب تنس أرضي" },
      { en: "Swimming Pool", ar: "مسبح" },
      { en: "Squash Court", ar: "ملعب اسكواش" },
      { en: "Pickleball Court", ar: "ملعب بيكل بول" },
      { en: "Running Track", ar: "تراك" },
      { en: "Multi-purpose Sports Hall", ar: "صالة رياضية متعددة الاستخدامات" },
      { en: "Training Rooms", ar: "قاعات تدريبية" },
      { en: "Multiple Seating Areas", ar: "جلسات متعددة" },
      { en: "Cafeteria", ar: "كافتيريا" },
      { en: "Security & Safety", ar: "عوامل الأمن والأمان" },
      { en: "Internet (Wi-Fi)", ar: "انترنت" },
      { en: "Parking", ar: "موقف سيارات" }
    ],
    isMainBranch: true
  },
  {
    id: "nuseirat",
    slug: "nuseirat",
    region: "central",
    name: { en: "Nuseirat Branch", ar: "فرع النصيرات - الوسطى" },
    address: {
      en: "Nuseirat, Central Gaza, Palestine",
      ar: "النصيرات، الوسطى، فلسطين"
    },
    phone: "+970 599 000 003",
    image: "/placeholder.svg",
    availableSports: ["football", "swimming", "karate"],
    facilities: [
      { en: "Swimming Pool", ar: "مسبح" },
      { en: "Football Field", ar: "ملعب كرة قدم" },
      { en: "Sports Hall", ar: "صالة رياضية" }
    ]
  },
  {
    id: "khan-younis",
    slug: "khan-younis",
    region: "south",
    name: { en: "Khan Younis Branch", ar: "فرع خان يونس" },
    address: {
      en: "Khan Younis, Palestine",
      ar: "خان يونس، فلسطين"
    },
    phone: "+970 599 000 004",
    image: "/placeholder.svg",
    availableSports: ["football", "swimming", "karate"],
    facilities: [
      { en: "Swimming Pool", ar: "مسبح" },
      { en: "Football Field", ar: "ملعب كرة قدم" },
      { en: "Sports Hall", ar: "صالة رياضية" }
    ]
  },
  {
    id: "rafah",
    slug: "rafah",
    region: "south",
    name: { en: "Rafah Branch", ar: "فرع رفح" },
    address: {
      en: "Rafah, Palestine",
      ar: "رفح، فلسطين"
    },
    phone: "+970 599 000 005",
    image: "/placeholder.svg",
    availableSports: ["football", "swimming", "karate"],
    facilities: [
      { en: "Swimming Pool", ar: "مسبح" },
      { en: "Football Field", ar: "ملعب كرة قدم" },
      { en: "Sports Hall", ar: "صالة رياضية" }
    ]
  }
];
